import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <span>&copy; {new Date().getFullYear()} Rhodiumroot LLC</span>
          {/* <span className="separator">|</span> */}
          </div>
          <div className="footer-left">
          <Link to="/about">About</Link>
          <span className="separator">|</span>
          <Link to="/legal/terms">Terms & Conditions</Link>
          <span className="separator">|</span>
          <Link to="/legal/privacy">Privacy Policy</Link>
        </div>
        <div className="footer-right">
            <IconButton
                component="a"
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
            >
                <LinkedInIcon />
            </IconButton>
            <IconButton
                component="a"
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
            >
                <XIcon />
            </IconButton>
        </div>
      </div>
    </footer>
  );
};

export default Footer;